function GoogleDriveLogoSVG() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3409_41768)">
        <path d="M25 5L35 25H15L25 5Z" fill="#4285F4" />
        <path d="M15 25H35L25 45L15 25Z" fill="#34A853" />
        <path d="M5 25L15 5L25 25H5Z" fill="#FBBC05" />
        <path d="M25 25L15 45L5 25H25Z" fill="#EA4335" />
        <path d="M35 25L45 5L35 25Z" fill="#4285F4" />
        <path d="M25 25L35 45L45 25H25Z" fill="#34A853" />
      </g>
      <defs>
        <clipPath id="clip0_3409_41768">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(5 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default GoogleDriveLogoSVG;
